// Mock data for Saale Lounge

export const openingHours = [
  { day: 'Montag', hours: 'Ruhetag', isClosed: true },
  { day: 'Dienstag', hours: 'Ruhetag', isClosed: true },
  { day: 'Mittwoch', hours: '18:00 - 00:00', isClosed: false },
  { day: 'Donnerstag', hours: '18:00 - 00:00', isClosed: false },
  { day: 'Freitag', hours: '18:00 - 02:00', isClosed: false },
  { day: 'Samstag', hours: '18:00 - 02:00', isClosed: false },
  { day: 'Sonntag', hours: '18:00 - 00:00', isClosed: false }
];

// Warme Getränke
export const warmDrinks = {
  coffee: [
    { id: 1, name: 'Café Crema', price: '3,50 €' },
    { id: 2, name: 'Cappuccino', price: '3,50 €' },
    { id: 3, name: 'Latte Macchiato', price: '3,50 €' },
    { id: 4, name: 'Espresso', price: '3,50 €' }
  ],
  coffeeSpecials: [
    { id: 1, name: 'Café Crema', price: '3,30 €' },
    { id: 2, name: 'Cappuccino', price: '3,60 €' },
    { id: 3, name: 'Latte Macchiato', price: '3,80 €' },
    { id: 4, name: 'Espresso', price: '3,30 €' },
    { id: 5, name: 'Laktosefreie- oder Hafermilch', price: '+1,00 €' },
    { id: 6, name: 'Vanille Topping', price: '+1,00 €' },
    { id: 7, name: 'Karamell Topping', price: '+1,00 €' }
  ],
  tea: [
    { id: 1, name: 'Schwarztee', price: '4,00 €' },
    { id: 2, name: 'Grüner Tee', price: '4,00 €' },
    { id: 3, name: 'Kamille Tee', price: '4,00 €' },
    { id: 4, name: 'Früchte Tee', price: '4,00 €' },
    { id: 5, name: 'Türkischer Apfel Tee', price: '4,00 €' }
  ]
};

// Soft Drinks
export const softDrinks = {
  water: [
    { id: 1, name: 'Bad Brückenauer Still', price: '3,30 €', size: '0,5L' },
    { id: 2, name: 'Bad Brückenauer Medium', price: '3,30 €', size: '0,5L' },
    { id: 3, name: 'Bad Brückenauer Spritzig', price: '3,30 €', size: '0,5L' }
  ],
  cola: [
    { id: 1, name: 'Coca Cola', price: '3,50 €' },
    { id: 2, name: 'Coca Cola Zero', price: '3,50 €' },
    { id: 3, name: 'Mezzo Mix', price: '3,50 €' }
  ],
  tradeIsland: [
    { id: 1, name: 'Mint N\'Lime', price: '4,00 €' },
    { id: 2, name: 'Blueberry', price: '4,00 €' },
    { id: 3, name: 'Pfirsich', price: '4,00 €' },
    { id: 4, name: 'Melon', price: '4,00 €' }
  ],
  redBull: [
    { id: 1, name: 'Original', price: '4,00 €' },
    { id: 2, name: 'Weiß', price: '4,00 €' },
    { id: 3, name: 'Blau', price: '4,00 €' },
    { id: 4, name: 'Grün', price: '4,00 €' }
  ],
  bionade: [
    { id: 1, name: 'Holunder', price: '3,50 €' },
    { id: 2, name: 'Zitrone', price: '4,00 €' },
    { id: 3, name: 'Orange', price: '4,00 €' },
    { id: 4, name: 'Pink Grapefruit', price: '4,00 €' },
    { id: 5, name: 'Johannisbeere', price: '4,00 €' }
  ],
  juices: [
    { id: 1, name: 'Johannisbeere Schorle', price: '4,20 €' },
    { id: 2, name: 'Apfel Schorle', price: '4,20 €' },
    { id: 3, name: 'Maracuja Schorle', price: '4,20 €' },
    { id: 4, name: 'Mango Saft', price: '4,20 €' },
    { id: 5, name: 'Ananas Saft', price: '4,20 €' },
    { id: 6, name: 'Maracuja Saft', price: '4,20 €' },
    { id: 7, name: 'Orangen Saft', price: '4,20 €' },
    { id: 8, name: 'Cranberry Saft', price: '4,20 €' }
  ]
};

// Bier
export const beer = {
  draft: [
    { id: 1, name: 'Mönchshof Hell', price: '4,00 €' },
    { id: 2, name: 'Mönchshof Pils', price: '4,00 €' },
    { id: 3, name: 'Radler', price: '4,00 €' }
  ],
  bottle: [
    { id: 1, name: 'Kapuziner Hefe Weizen', price: '4,30 €' },
    { id: 2, name: 'Kapuziner Hefe Alkoholfrei', price: '4,30 €' },
    { id: 3, name: 'Pils Naturtrüb Alkoholfrei', price: '4,30 €' },
    { id: 4, name: 'Naturradler Alkoholfrei', price: '4,30 €' }
  ]
};

// Cocktails mit Sahne
export const cocktailsWithCream = [
  { id: 1, name: 'Pina Colada', description: 'Kokosnuss, Ananas, Rum, Sahne', price: '7,50 €', image: 'https://images.unsplash.com/photo-1568586371584-91f1d8f9f3d7' },
  { id: 2, name: 'Baileys Colada', description: 'Irish Baileys, Batida De Coco, Ananas, Kokosnuss, Sahne', price: '7,50 €', image: 'https://images.unsplash.com/photo-1577708572048-6d16c1c01ecf' },
  { id: 3, name: 'Strawberry Colada', description: 'Erdbeere, Ananas, Weißer Rum, Sahne', price: '7,50 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 4, name: 'Ed von Schleck', description: 'Erdbeere, Maracuja, Karamell, Vodka, Sahne', price: '7,50 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19', isSignature: true },
  { id: 5, name: 'Swimming Pool', description: 'Blue Curacao, Kokosnuss, Ananas, Weißer Rum, Sahne', price: '7,50 €', image: 'https://images.unsplash.com/photo-1514362545857-3bc16c4c7d1b' },
  { id: 6, name: 'Moe Spezial', description: 'Erdbeere, Cranberry, Johannisbeere, Vanille, Karamell, Vodka, Sahne', price: '7,50 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19', isSignature: true }
];

// Cocktails ohne Sahne
export const cocktailsWithoutCream = [
  { id: 1, name: 'Touch Down', description: 'Orange, Maracuja, Zitrone, Grenadine, Vodka, Apricot', price: '7,50 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 2, name: 'Sex on the Beach', description: 'Orange, Himbeere, Cranberry, Vodka, Apricot', price: '7,50 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 3, name: 'Melon Cooler', description: 'Orange, Maracuja, Zitrone, Melone, Vodka, Apricot', price: '7,50 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 4, name: 'Mango Exotic', description: 'Mango, Maracuja, Vanille, Vodka', price: '7,50 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 5, name: 'Kiba Royal', description: 'Kirsch, Banane, Rum, Vodka', price: '7,50 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 6, name: 'Vanilla Sky', description: 'Trauben, Zitrone, Vanille, Rohrzucker, Vodka', price: '7,50 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 7, name: 'Tequila Sunrise', description: 'Orange, Himbeere, Grenadine, Tequila', price: '7,50 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 8, name: 'Long Island Ice Tea', description: 'Zitrone, Cola, Triple Sec, Rum, Vodka, Gin, Tequila', price: '8,00 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 9, name: 'Gin Bramble', description: 'Brombeere, Zitrone, Zuckersirup, Franziska Gin', price: '8,00 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 10, name: 'Copacabana', description: 'Minze, Limette, Grenadine, Batida De Coco, Secco', price: '7,50 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 11, name: 'Whisky Sour', description: 'Zitrone, Zucker, Franziska Whisky', price: '8,00 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 12, name: 'Moscow Mule', description: 'Limette, Vodka, Ginger Beer, Gurke', price: '7,50 €', image: 'https://images.unsplash.com/photo-1648663056174-1b93124c6000' },
  { id: 13, name: 'Gin Fizz Franzi', description: 'Frizzoli, Franziska Gin, Zitrone, Soda', price: '8,00 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 14, name: 'Negroni', description: 'Franziska Gin, Campari, Roter Wermut', price: '8,00 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 15, name: 'Espresso Martini', description: 'Zuckersirup, Kaffeelikör, Espresso, Vodka', price: '8,00 €', image: 'https://images.unsplash.com/photo-1605270012917-bf157c5a9541' }
];

// Mojitos
export const mojitos = [
  { id: 1, name: 'Mojito', description: 'Minze, Limette, Brauner Zucker, Ginger Ale, Rum', price: '7,50 €', image: 'https://images.unsplash.com/photo-1648663056565-2489aa5714d3' },
  { id: 2, name: 'Mojito Wassermelone', description: 'Minze, Limette, Brauner Zucker, Wassermelone, Rum', price: '7,50 €', image: 'https://images.unsplash.com/photo-1648663056565-2489aa5714d3' },
  { id: 3, name: 'Mojito Erdbeere', description: 'Minze, Limette, Brauner Zucker, Erdbeere, Soda, Rum', price: '7,50 €', image: 'https://images.unsplash.com/photo-1648663056565-2489aa5714d3' },
  { id: 4, name: 'Mojito Maracuja', description: 'Minze, Limette, Brauner Zucker, Maracuja, Soda, Rum', price: '7,50 €', image: 'https://images.unsplash.com/photo-1648663056565-2489aa5714d3' }
];

// Longdrinks
export const longdrinks = [
  { id: 1, name: 'Gin Wild Berry', description: 'Franziska Gin, Wild Berry, Beeren', price: '8,00 €' },
  { id: 2, name: 'Gin Tonic', description: 'Franziska Gin, Tonic Water, Gurke oder Zitrone', price: '8,00 €' },
  { id: 3, name: 'Cuba Libré', description: 'Havana, Cola, Limette', price: '7,00 €' },
  { id: 4, name: 'Bacardi Cola', description: 'Bacardi, Cola', price: '6,80 €' },
  { id: 5, name: 'Asbach Cola', description: 'Asbach, Cola', price: '6,80 €' },
  { id: 6, name: 'Vodka Red Bull', description: 'Vodka, Red Bull', price: '7,00 €' },
  { id: 7, name: 'Jack Daniel\'s Cola', description: 'Jack Daniels, Cola', price: '6,80 €' }
];

// Aperitif
export const aperitif = [
  { id: 1, name: 'Hugo', description: 'Minze, Limette, Holunderblüte, Secco, Soda', price: '6,80 €' },
  { id: 2, name: 'Lillet Wild Berry', description: 'Lillet, Wild Berry, Beeren', price: '6,80 €' },
  { id: 3, name: 'Aperol Spritz', description: 'Aperol, Secco, Soda, Orange', price: '6,80 €' },
  { id: 4, name: 'Aperol Sour', description: 'Aperol, Zitronensaft, Orangensaft, Orangen', price: '6,80 €' },
  { id: 5, name: 'Déjá-Vu Grapefruit', description: 'Déjá-Vu, Frische Grapefruit, White Peach', price: '7,00 €' },
  { id: 6, name: 'Campari Spritz', description: 'Campari, Secco, Soda, Orange', price: '6,90 €' }
];

// Alkoholfreie Cocktails
export const cocktailsNonAlcoholic = [
  { id: 1, name: 'Coconut Kiss', description: 'Kokosnuss, Grenadine, Ananas, Sahne, Blue Curacao', price: '7,00 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 2, name: 'Baby Colada', description: 'Kokosnuss, Ananas, Sahne', price: '7,00 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 3, name: 'Virgin Ed von Schleck', description: 'Erdbeere, Maracuja, Karamell, Sahne', price: '7,00 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 4, name: 'Mona Lisa', description: 'Mango, Maracuja, Orange, Vanille, Sahne', price: '7,00 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 5, name: 'Virgin Moe Spezial', description: 'Erdbeere, Vanille, Karamell, Johannisbeere, Cranberry, Sahne', price: '7,00 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 6, name: 'Virgin Mojito', description: 'Minze, Limette, Brauner Zucker, Ginger Ale', price: '7,00 €', image: 'https://images.unsplash.com/photo-1648663056565-2489aa5714d3' },
  { id: 7, name: 'Virgin Mojito Wassermelone', description: 'Minze, Limette, Brauner Zucker, Wassermelone, Cranberry', price: '7,00 €', image: 'https://images.unsplash.com/photo-1648663056565-2489aa5714d3' },
  { id: 8, name: 'Virgin Mojito Erdbeere', description: 'Minze, Limette, Brauner Zucker, Soda, Erdbeere', price: '7,00 €', image: 'https://images.unsplash.com/photo-1648663056565-2489aa5714d3' },
  { id: 9, name: 'Virgin Mojito Maracuja', description: 'Minze, Limette, Brauner Zucker, Maracuja, Soda', price: '7,00 €', image: 'https://images.unsplash.com/photo-1648663056565-2489aa5714d3' },
  { id: 10, name: 'Easy Driver', description: 'Zitrone, Himbeere, Grenadine, Orange, Maracuja', price: '7,00 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 11, name: 'Virgin Hugo', description: 'Minze, Limette, Holunderblüte, Soda, Secco Alkoholfrei', price: '6,50 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' },
  { id: 12, name: 'Kiba', description: 'Kirsch, Banane', price: '6,00 €', image: 'https://images.unsplash.com/photo-1587223962930-cb7f31384c19' }
];

// Legacy export for backwards compatibility
export const cocktails = cocktailsWithCream;

// Für den kleinen Hunger - Speisekarte
export const foodMenu = {
  brotzeit: [
    { id: 1, name: 'Kräuterbaguette Hälfte', description: 'Baguette, Knoblauchcrème-Belag (vegetarisch)', price: '5,00 €' },
    { id: 2, name: 'Griechische Art', description: 'Feta-Käse, grüne Peperoni, Schmand, Petersilie (vegetarisch)', price: '5,00 €' },
    { id: 3, name: 'Käsewürfel, Weintrauben mit Brezel', description: '(vegetarisch)', price: '5,00 €' },
    { id: 4, name: 'Salzbrezel', description: '(vegetarisch)', price: '2,00 €' },
    { id: 5, name: 'Salzbrezel mit Butter', description: '(vegetarisch)', price: '3,50 €' }
  ],
  flammkuchen: [
    { id: 1, name: 'Original Elsässer Art', description: 'Zwiebel, Speck, Schmand', price: '8,30 €' },
    { id: 2, name: 'Nordischer Art', description: 'Wildlachs, Zwiebel, Lauch, Dill, Schmand', price: '8,30 €' }
  ],
  pinsa: [
    { id: 1, name: 'Steinofenpinsa Kebab', description: 'Hähnchenkebab, Dönersoße, Paprika', price: '8,30 €' },
    { id: 2, name: 'Steinofenpinsa Spianata Romana', description: 'Salami (Schwein), Paprika', price: '5,50 €' },
    { id: 3, name: 'Steinofenpinsa Tomate-Rucola', description: 'Tomate, Rucola, versch. Käse (vegetarisch)', price: '3,50 €' }
  ]
};

export const shishaFlavors = [
  {
    id: 1,
    name: '187 - Hamburg',
    description: 'Erdbeere, Himbeere, Johannisbeere, Brombeere',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1630175772812-3368aad7982d'
  },
  {
    id: 2,
    name: 'Almassiva - Blaulicht',
    description: 'Drachenfrucht, Himbeere, Pfirsich',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1635547821500-77542481940c'
  },
  {
    id: 3,
    name: 'Almassiva - Nightkiller',
    description: 'Brombeere, Johannisbeere, Maulbeere, Drachenfrucht, Menthol',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1662805522314-d316b95046b1'
  },
  {
    id: 4,
    name: 'Almassiva - 5 Palm',
    description: 'Maracuja, Blaubeere, Erdbeere, Mango',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1630175772812-3368aad7982d'
  },
  {
    id: 5,
    name: 'Holster - Ice Kaktuz',
    description: 'Ice, Kaktusfeige',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1635547821500-77542481940c'
  },
  {
    id: 6,
    name: 'Holster - Miss Joosy',
    description: 'Himbeere, Ice, Erdbeere',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1630175772812-3368aad7982d'
  },
  {
    id: 7,
    name: 'Holster - Watermill Punch',
    description: 'Ice, Wassermelone',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1635547821500-77542481940c'
  },
  {
    id: 8,
    name: 'MBM - Himiko',
    description: 'Drachenfrucht, Kiwi, Himbeere, Limette',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1662805522314-d316b95046b1'
  },
  {
    id: 9,
    name: 'Nameless - Black Nana',
    description: 'Traube, Minze',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1630175772812-3368aad7982d'
  },
  {
    id: 10,
    name: 'O\'s Tobacco - Disco',
    description: 'Saure Zitrone, Süßer Pfirsich',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1635547821500-77542481940c'
  },
  {
    id: 11,
    name: 'O\'s Tobacco - African Queen',
    description: 'Früchtemix',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1662805522314-d316b95046b1'
  },
  {
    id: 12,
    name: 'O\'s Tobacco - Unknown',
    description: 'Kaktusfeige, Früchtemix, Minze',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1630175772812-3368aad7982d'
  },
  {
    id: 13,
    name: 'Almassiva - Pink King',
    description: 'Himbeere',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1635547821500-77542481940c'
  },
  {
    id: 14,
    name: 'Almassiva - Blue Beast',
    description: 'Ananas, Brombeere, Blaubeere',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1662805522314-d316b95046b1'
  },
  {
    id: 15,
    name: 'Holster - Ice Finger',
    description: 'Himbeere, Limette',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1630175772812-3368aad7982d'
  },
  {
    id: 16,
    name: '27er - KiGa',
    description: 'Granatapfel, Kirsche',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1635547821500-77542481940c'
  },
  {
    id: 17,
    name: 'Bad&Mad - Flamingo',
    description: 'Maracuja, Grapefruit, Mango',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1662805522314-d316b95046b1'
  },
  {
    id: 18,
    name: 'True Passion - Okolom CB10',
    description: 'Zitrone, Himbeere, Holunder, Cranberry',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1630175772812-3368aad7982d'
  },
  {
    id: 19,
    name: 'Start Now - Joker',
    description: 'Zitronenkuchen',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1635547821500-77542481940c'
  },
  {
    id: 20,
    name: 'Argileh - Frixxy',
    description: 'Beerenmix',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1662805522314-d316b95046b1'
  },
  {
    id: 21,
    name: 'SaVu - Cheftali',
    description: 'Eistee Pfirsich',
    price: '14,00 €',
    image: 'https://images.unsplash.com/photo-1630175772812-3368aad7982d'
  }
];

// Shisha Preise
export const shishaPrices = {
  standard: '14,00 €',
  kopfwechsel: '11,00 €'
};

// Weine 0,25 Liter
export const wines025 = [
  { id: 1, name: 'Müller Thurgau Trocken', winery: 'Weingut Lange', price: '6,00 €' },
  { id: 2, name: 'Perle Fruchtig-Zart', winery: 'Weingut Lange', price: '6,00 €' },
  { id: 3, name: 'Müller Thurgau Trocken', winery: 'Weingut Müller', price: '6,00 €' },
  { id: 4, name: 'Perle Fruchtig-Zart', winery: 'Weingut Müller', price: '6,00 €' },
  { id: 5, name: 'Läuft ROT Halbtrocken', winery: 'Weingut Müller', price: '5,50 €' },
  { id: 6, name: 'Läuft WEIß Halbtrocken', winery: 'Weingut Müller', price: '5,50 €' },
  { id: 7, name: 'HAB-Burg Sauvignon Blanc Trocken', winery: 'Weingut Schäfer', price: '6,00 €' },
  { id: 8, name: 'Rosé Trocken', winery: 'Weingut Schäfer', price: '6,00 €' },
  { id: 9, name: 'Silvaner Trocken', winery: 'Weingut Schäfer', price: '6,00 €' },
  { id: 10, name: 'Bacchus Kabinett Feinfruchtig', winery: 'Weingut Schäfer', price: '6,00 €' },
  { id: 11, name: 'Bacchus Trocken', winery: 'Weingut Ruppert', price: '5,50 €' },
  { id: 12, name: 'Edition "Pink Lady" Halbtrocken', winery: 'Weingut Hümmler', price: '5,50 €' }
];

// Weine 0,75 Liter
export const wines075 = [
  { id: 1, name: 'Rhöngold Cuvée Lieblich', winery: 'Weingut Lange', price: '17,50 €' },
  { id: 2, name: 'Rotling Halbtrocken', winery: 'Weingut Lange', price: '23,00 €' },
  { id: 3, name: 'Müller Thurgau Trocken', winery: 'Weingut Müller', price: '20,00 €' },
  { id: 4, name: 'Sauvignon Blanc Trocken', winery: 'Weingut Müller', price: '17,50 €' },
  { id: 5, name: 'HAB-Heroldsberg Weißburgunder Trocken', winery: 'Weingut Schäfer', price: '23,00 €' },
  { id: 6, name: 'Riesling Kalkstein Trocken', winery: 'Weingut Schäfer', price: '16,50 €' },
  { id: 7, name: 'Gewürztraminer Spätlese', winery: 'Weingut Schäfer', price: '19,50 €' },
  { id: 8, name: 'Grauburgunder Trocken', winery: 'Weingut Schäfer', price: '19,50 €' },
  { id: 9, name: 'Rotling Feinfruchtig', winery: 'Weingut Schäfer', price: '19,50 €' },
  { id: 10, name: 'Domina Trocken', winery: 'Weingut Ruppert', price: '17,50 €' },
  { id: 11, name: 'Kerner Trocken', winery: 'Weingut Hümmler', price: '16,50 €' }
];

// Secco
export const secco = [
  { id: 1, name: 'Secco Weingut Schäfer', price: '3,00 €', size: '0,1L' },
  { id: 2, name: 'Traubensecco Alkoholfrei Weingut Ruppert', price: '3,00 €', size: '0,1L' },
  { id: 3, name: 'Weinschorle süß oder sauer', price: '5,00 €' },
  { id: 4, name: 'Rotling Schorle', price: '5,00 €' }
];

// Schnäpse
export const schnapps = {
  franziska: [
    { id: 1, name: 'Musterknabe - Der Williams', price: '4,00 €' },
    { id: 2, name: 'Fräulein - Die Mirabelle', price: '4,00 €' },
    { id: 3, name: 'Schamane - Der Ingwergeist', price: '4,00 €' },
    { id: 4, name: 'Halunke - Johannisbeere', price: '4,00 €' },
    { id: 5, name: 'Dickkopf - Haselnussgeist', price: '4,00 €' }
  ],
  klassiker: [
    { id: 1, name: 'Jägermeister', price: '3,00 €' },
    { id: 2, name: 'Apfelstrudel', price: '3,00 €' },
    { id: 3, name: 'Ficken', price: '3,00 €' },
    { id: 4, name: 'Pfeffi', price: '2,50 €' },
    { id: 5, name: 'Tequila Gold', price: '3,00 €' },
    { id: 6, name: 'Tequila Silber', price: '3,00 €' }
  ]
};

// Legacy wines export (for backwards compatibility)
export const wines = wines025;

// Saale Beach Events (Mai - August 2026)
export const beachEvents = [
  // Mai
  { id: 1, date: 'Samstag 02.05.26', artist: 'DJ El\'Buitre', description: 'Mixed-up das beste aller Jahrzehnte', month: 'Mai' },
  { id: 2, date: 'Donnerstag 14.05.26', artist: 'DeLuchs', description: 'Acoustic Rock', month: 'Mai' },
  { id: 3, date: 'Samstag 23.05.26', artist: 'The Teachers', description: 'Rock, Blues-Rock und mehr', month: 'Mai' },
  { id: 4, date: 'Freitag 29.05.26', artist: 'DJ Rolli', description: 'Die besten Party Hits', month: 'Mai' },
  
  // Juni
  { id: 5, date: 'Mittwoch 10.06.26', artist: '3 Style', description: 'Partyband', month: 'Juni' },
  { id: 6, date: 'Samstag 13.06.26', artist: 'DJ El\'Buitre', description: 'Eisdiele Revival Summerparty', month: 'Juni' },
  { id: 7, date: 'Samstag 20.06.26', artist: 'Elotail', description: 'Elektronische Tanzmusik', month: 'Juni' },
  { id: 8, date: 'Sonntag 21.06.26', artist: 'Didi Blender', description: 'Country, Oldies, Rock Pop Musik', month: 'Juni' },
  { id: 9, date: 'Freitag 26.06.26', artist: 'Dicker und Bänd', description: 'Schlager bis Rock', month: 'Juni' },
  
  // Juli
  { id: 10, date: 'Sonntag 05.07.26', artist: 'Didi Blender', description: 'Country, Oldies, Rock Pop Musik', month: 'Juli' },
  { id: 11, date: 'Samstag 11.07.26', artist: 'Lady-Out', description: '40 Years of Rock', month: 'Juli' },
  { id: 12, date: 'Sonntag 26.07.26', artist: 'Dicker und Bänd', description: 'Schlager bis Rock', month: 'Juli' },
  
  // August
  { id: 13, date: 'Samstag 01.08.26', artist: 'Elotail', description: 'Elektronische Tanzmusik', month: 'August' },
  { id: 14, date: 'Sonntag 02.08.26', artist: 'Didi Blender', description: 'Country, Oldies, Rock Pop Musik', month: 'August' },
  { id: 15, date: 'Freitag 14.08.26', artist: 'DJ Rolli', description: 'Beachparty', month: 'August' },
  { id: 16, date: 'Samstag 22.08.26', artist: 'DJ El\'Buitre', description: 'Besten Disco Songs der 70er, 80er & 90er', month: 'August' },
  { id: 17, date: 'Samstag 29.08.26', artist: 'Siwa B2B Paul Zieger', description: 'Melodic Techno', month: 'August' }
];

export const events = [
  {
    id: 1,
    name: 'Event',
    description: '',
    day: '',
    time: '',
    icon: '🎵'
  }
];

export const galleryImages = [
  {
    id: 1,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/5h6ns2wd_IMG-20260315-WA0021.jpg',
    alt: 'Saale Lounge Interior',
    category: 'interior'
  },
  {
    id: 2,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/nv6xvpde_IMG-20260327-WA0105.jpg',
    alt: 'Cocktails im Neonlicht',
    category: 'drinks'
  },
  {
    id: 3,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/ryf5u5a6_IMG-20260327-WA0103.jpg',
    alt: 'Premium Cocktails an der Bar',
    category: 'drinks'
  },
  {
    id: 4,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/e4xtqiiu_IMG-20260327-WA0097.jpg',
    alt: 'Signature Cocktails',
    category: 'drinks'
  },
  {
    id: 5,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/7nojaqky_IMG-20260327-WA0087.jpg',
    alt: 'Cocktail Spezialität',
    category: 'drinks'
  },
  {
    id: 6,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/wxo1mk8q_IMG-20260327-WA0089.jpg',
    alt: 'Saale Lounge Atmosphäre',
    category: 'interior'
  },
  {
    id: 7,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/szmtv8aa_IMG-20260327-WA0111.jpg',
    alt: 'Bar Bereich',
    category: 'interior'
  },
  {
    id: 8,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/4a7dyh4g_IMG-20260327-WA0095.jpg',
    alt: 'Exklusive Cocktails',
    category: 'drinks'
  },
  {
    id: 9,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/bx3nltye_IMG-20260327-WA0072.jpg',
    alt: 'Lounge-Bereich',
    category: 'interior'
  },
  {
    id: 10,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/xzumj0td_IMG-20260327-WA0067.jpg',
    alt: 'Lokale Weine',
    category: 'wine'
  },
  {
    id: 11,
    url: 'https://customer-assets.emergentagent.com/job_cocktail-vibes/artifacts/b6nvoxzy_IMG-20260327-WA0066.jpg',
    alt: 'Handgefertigter Cocktail',
    category: 'drinks'
  }
];

export const contactInfo = {
  name: 'Saale Lounge',
  address: 'Am Bleichrasen, 97762 Hammelburg',
  phone: '+49 179 6674356',
  whatsapp: '+491796674356',
  instagram: '@saale_lounge',
  description: `Die Saale Lounge in Hammelburg ist eine moderne Cocktail- und Shishabar, die für entspannte Abende in stilvoller Atmosphäre steht. Hier treffen hochwertige Drinks, gemütliches Lounge-Ambiente und geselliges Beisammensein aufeinander. Gäste können aus einer großen Auswahl an Cocktails, Longdrinks und Spirituosen wählen und den Abend in einer angenehmen und modernen Umgebung genießen.

Auch Weinliebhaber aus der Region kommen in der Saale Lounge auf ihre Kosten. Neben klassischen Bar-Getränken bietet die Lounge eine Auswahl an Qualitätsweinen aus der Umgebung, die perfekt für einen entspannten Abend mit Freunden oder in geselliger Runde geeignet sind.

Die Saale Lounge ist in zwei Bereiche unterteilt: einen Cocktail- und Weinbereich, in dem Gäste ihre Drinks in ruhiger Lounge-Atmosphäre genießen können, sowie einen separaten Shisha-Bereich für alle, die Shisha in gemütlicher und geselliger Umgebung rauchen möchten.

Damit vereint die Saale Lounge Cocktailbar, Weinlounge und Shishabar an einem Ort und bietet sowohl für Genießer als auch für Nachtschwärmer den perfekten Treffpunkt in Hammelburg.`
};
